// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import RoundedButton from '../../../../components/RoundedButton';
import { __ } from '../../../../i18n/l10n';
import theme from '../../../../styled-components/dark';

const Wrapper = styled.div`
  position: relative;
`;

const StyledButton = styled(RoundedButton)`
  box-sizing: border-box;
  width: 100%;
  height: 2.27em;
`;

const Center = styled.div`
  position: absolute;
  pointer-events: none;
  background: transparent;
  left: 50%;
  top: 50%;
`;

type props = {
  className?: string;
  betslipReference: string;
  uuid: string;
  onClick: () => void;
};

const BetslipOptionRepeatBetButton = ({ className = '', onClick, uuid, betslipReference }: props) => {
  return (
    <Wrapper className={className}>
      <Center id={`odd-button-${betslipReference}-${uuid}`} />
      <StyledButton
        onClick={onClick}
        label={__('Repeat this bet')}
        color={theme.History.betslip.actions.buttonColor}
        backgroundColor={theme.History.betslip.actions.completeButtonBackgroundColor}
      />
    </Wrapper>
  );
};

export default BetslipOptionRepeatBetButton;
